import { c as _c } from "react/compiler-runtime";
// Styled mode discards the JS `fillColor` gradient, so the per-series area fade
// (the series colour at 0.2 opacity at the line, fading to transparent at the
// baseline — direction 'down', minOpacity 0.2 → maxOpacity 0) is provided here
// as SVG gradient defs and referenced from charts.css:
// `.hc-styled-chart .highcharts-color-N .highcharts-area { fill: url(#hc-area-gradient-N) }`.
//
// `stop-color`/`stop-opacity` are set via `style` (CSS) rather than SVG
// presentation attributes, because `var(--series-N)` only resolves as a CSS
// value. Rendered inside every Chart; the ids repeat when a page has several
// charts, but the defs are identical so `url(#…)` resolving to the first in
// document order is always correct.

const SERIES_COUNT = 10;
export function ChartAreaGradients() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <svg aria-hidden={true} focusable="false" width={0} height={0} style={{
      position: "absolute"
    }}><defs>{Array.from({
          length: SERIES_COUNT
        }, _temp)}</defs></svg>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
function _temp(_, i) {
  return <linearGradient key={i} id={`hc-area-gradient-${i}`} x1="0" y1="0" x2="0" y2="1"><stop offset="0%" style={{
      stopColor: `var(--series-${i})`,
      stopOpacity: 0.2
    }} /><stop offset="100%" style={{
      stopColor: `var(--series-${i})`,
      stopOpacity: 0
    }} /></linearGradient>;
}